import { IOnboardingStep } from '~/@api/generated-api-types-user/Api'
import type { UserWithMeta } from '~/@biz_account/useUser/types'

export const STEPS_EXPIRED_ANALYSIS = [
  { title: 'Investičný dotazník', minutes: 3 },
  { title: 'Simulácia investičného rizika', minutes: 2 },
]

/** Expirovaný doklad totožnosti (BE `hasExpiredIdentityDocument`): nový Veriff + potvrdenie údajov. */
export const STEPS_EXPIRED_IDENTITY = [
  { title: 'Overenie dokladu totožnosti', minutes: 1 },
  { title: 'Kontrola údajov', minutes: 1 },
]

/** Po novom Veriffe BE vráti krok `identityVerificationConfirmed` → 2. krok stepperu. */
export const getExpiredIdentityActiveStepIndex = (user: UserWithMeta | null) =>
  user?.onboarding.currentRequiredStep ===
  IOnboardingStep.IdentityVerificationConfirmed
    ? 1
    : 0

export type Step = { title: string; minutes: number }

export function getSteps(user: UserWithMeta | null) {
  const isCompany = user?.profile?.isCompany
  if (isCompany) {
    return [
      { title: 'Overenie identity', minutes: 1 },
      { title: 'Overenie firemných údajov', minutes: 2 },
      { title: 'Investorský dotazník', minutes: 5 },
      { title: 'Podpis rámcovej zmluvy', minutes: 1 },
    ]
  }
  return [
    { title: 'Overenie identity', minutes: 1 },
    { title: 'Investorský dotazník', minutes: 5 },
    { title: 'Podpis rámcovej zmluvy', minutes: 1 },
  ]
}

export const getActiveStepIndex = (user: UserWithMeta | null) => {
  const step = user?.onboarding.currentRequiredStep
  const isCompany = user?.profile?.isCompany
  if (
    step === IOnboardingStep.IdentityVerification ||
    step === IOnboardingStep.IdentityVerificationConfirmed
  )
    return 0 // Overenie identity

  if (
    step === IOnboardingStep.CompanyFormCompletion ||
    step === IOnboardingStep.CompanyFormAdminConfirmation
  )
    return isCompany ? 1 : 0 // Overenie firemných údajov

  if (step === IOnboardingStep.QuestionnaireCompletion) return isCompany ? 2 : 1 //Dotazník
  if (step === IOnboardingStep.ContractSignature) return isCompany ? 3 : 2 // Podpis
  return -1
}

export const steps = [
  'Overenie firemných údajov',
  'Potvrdenie administrátorom',
  'Investorský dotazník',
  'Podpis rámcovej zmluvy',
]
